import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from 'react-router-dom';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Card,
  CardContent,
} from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import StarBorderIcon from "@mui/icons-material/StarBorder";
import { useAuth } from '../context/AuthContext';

import { getProductReview } from '../service/productReview'; 
export default function ProductViewReview({product, onClose}) {
const productId = product?.productId;
    const [reviews, setReviews] = useState(null);
    const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if(productId){
    if(!user){
      navigate("/login");
      return;
    }
    getProductReview(productId).then((res) => {
      setReviews(res.data);
      product.reviews = res.data;
    });
    } 
    
  }, [productId]);

  if (!product) return <p>Loading...</p>;

  return (
    <Dialog open={!!productId} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>{product.productName}</DialogTitle>
      <DialogContent dividers>
        <div className="p-2">
          <p>{product.description}</p>

          {/* Average rating */}
          <div className="flex items-center mt-2">
            {Array.from({ length: 5 }).map((_, index) =>
              index < Math.round(product.averageRating) ? (
                <StarIcon key={index} sx={{ color: "gold" }} />
              ) : (
                <StarBorderIcon key={index} sx={{ color: "gray" }} />
              )
            )}
            <span className="ml-2 text-sm text-gray-600">
              {product.averageRating?.toFixed(1)} / 5
            </span>
          </div>

          {/* Reviews */}
          <h2 className="mt-4 text-lg font-semibold">Customer Reviews</h2>
          {reviews?.length > 0 ? (
            reviews.map((review) => (
              <Card key={review.reviewId} className="mt-2 shadow rounded-lg">
                <CardContent>
                  <div className="flex items-center">
                    {Array.from({ length: 5 }).map((_, index) =>
                      index < review.rating ? (
                        <StarIcon key={index} sx={{ color: "gold" }} />
                      ) : (
                        <StarBorderIcon key={index} sx={{ color: "gray" }} />
                      )
                    )}
                    <h4 className="ml-2 text-sm text-gray-700 font-semibold">
                      {review.title}
                    </h4>
                  </div>
                  <p className="text-gray-800 mt-1">{review.reviewText}</p>
                  <p className="text-xs text-gray-500">
                     {new Date(review.createdAt).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'long',
    year: 'numeric',
  })}
</p>
                </CardContent>
              </Card>
            ))
          ) : (
            <p className="text-gray-500 mt-2">No reviews yet.</p>
          )}
        </div>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}
